import type { TgnBannerProps } from './TgnBanner.d';

import Banner1 from '~/assets/images/banner1.png';

export const useTgnBanner = () => {
  const hasBanner = ref(true);
  const banner = reactive<TgnBannerProps>({
    title: '',
    subtitle: '',
    backgroundImage: undefined,
    variant: undefined,
    description: undefined,
    isMainContentVisible: true,
    isExtraContentVisible: false,
  });

  const isBannerVisible = computed(() => hasBanner.value);

  return {
    banner,
    isBannerVisible,
    showBanner,
    hideBanner,
    setBannerTitle,
    setBannerSubtitle,
    setBannerBgColor,
    setBannerBgImage,
    setBannerVariant,
    setBannerDescription,
    restoreDefault,
    showMainContent,
    hideMainContent,
  };

  function showBanner() {
    hasBanner.value = true;
  }

  function hideBanner() {
    hasBanner.value = false;
  }

  function setBannerTitle(title: string) {
    banner.title = title;
  }

  function setBannerSubtitle(subtitle: string) {
    banner.subtitle = subtitle;
  }

  function setBannerBgColor(color: string) {
    banner.bgColor = color;
  }

  function setBannerBgImage(image: string = Banner1) {
    banner.backgroundImage = image;
  }

  function setBannerVariant(variant: 'large' | 'slim' = 'large') {
    banner.variant = variant;

    console.warn(
      'A propriedade "variant" do banner será removida em breve. Utilize "isMainContentVisible" e "isExtraContentVisible" para controlar a visibilidade do conteúdo principal e extra.',
    );
  }

  function setBannerDescription(description: string) {
    banner.description = description;
  }

  function showMainContent() {
    banner.isMainContentVisible = true;
  }

  function hideMainContent() {
    banner.isMainContentVisible = false;
  }

  function restoreDefault() {
    banner.bgColor = undefined;
    banner.backgroundImage = undefined;
    banner.description = undefined;
    banner.subtitle = '';
    banner.title = '';
    banner.variant = 'large';
    setBannerBgImage();
  }
};
